import React from 'react';

// Function to check the text, detect and convert URLs into clickable links
export const convertUrlsToLinks = (text) => {
  const safeText = String(text ?? '');
  // Regex to capture different types of URLs (http://, https://, www., and domain names)
  const urlRegex = /(?:https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(?:[^\s]*)/g;

  const parts = [];
  let lastIndex = 0;

  safeText.replace(urlRegex, (match, offset) => {
    parts.push(safeText.slice(lastIndex, offset));

    const validUrl = match.startsWith('www.') ? `http://${match}` : match;
    parts.push(
      <a
        key={offset}
        href={validUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-600 hover:text-blue-800 hover:underline"
      >
        {match}
      </a>,
    );
    lastIndex = offset + match.length;
  });

  parts.push(safeText.slice(lastIndex));
  return <>{parts}</>;
};
